import React from 'react';
import Icon from '../../../components/AppIcon';

const ParkingTransit = () => {
  const parkingOptions = [
    {
      icon: "Car",
      title: "Free Street Parking",
      description: "Ample free parking available on Etobicoke Street and surrounding residential streets",
      details: "No time restrictions on weekends"
    },
    {
      icon: "ParkingCircle",
      title: "Parking Lot",
      description: "Dedicated parking lot behind the bakery with 15 spaces",
      details: "Accessible entrance available"
    },
    {
      icon: "Bike",
      title: "Bike Parking",
      description: "Secure bike racks located at the front entrance",
      details: "Covered area to protect from weather"
    }
  ];

  const transitOptions = [
    {
      icon: "Bus",
      route: "TTC Bus 37",
      description: "Stops directly in front of bakery",
      walkTime: "0 min walk"
    },
    {
      icon: "Train",
      route: "Kipling Station",
      description: "Line 2 Bloor-Danforth",
      walkTime: "8 min walk"
    },
    {
      icon: "Tram",
      route: "TTC Bus 123",
      description: "Stops 2 blocks away",
      walkTime: "3 min walk"
    }
  ];

  return (
    <div className="bg-card rounded-2xl overflow-hidden shadow-warm">
      <div className="p-6 border-b border-border">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name="Navigation" size={20} color="var(--color-primary)" />
          </div>
          <h2 className="text-2xl font-serif font-semibold text-foreground">
            Getting Here
          </h2>
        </div>
        <p className="text-muted-foreground">
          Easy access by car, bike, or public transit
        </p>
      </div>
      <div className="p-6">
        <div className="mb-8">
          <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
            <Icon name="Car" size={20} color="var(--color-primary)" />
            Parking Options
          </h3>
          <div className="space-y-3">
            {parkingOptions?.map((option, index) => (
              <div
                key={index}
                className="p-4 rounded-xl bg-muted/30 border border-border hover:border-primary/20 transition-all"
              >
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon name={option?.icon} size={20} color="var(--color-primary)" />
                  </div>
                  <div className="flex-1">
                    <h4 className="font-medium text-foreground mb-1">
                      {option?.title}
                    </h4>
                    <p className="text-sm text-muted-foreground mb-2">
                      {option?.description}
                    </p>
                    <p className="text-xs text-accent font-medium">
                      {option?.details}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
            <Icon name="Bus" size={20} color="var(--color-primary)" />
            Public Transit
          </h3>
          <div className="space-y-3">
            {transitOptions?.map((option, index) => (
              <div
                key={index}
                className="p-4 rounded-xl bg-muted/30 border border-border"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                      <Icon name={option?.icon} size={20} color="var(--color-primary)" />
                    </div>
                    <div>
                      <p className="font-medium text-foreground">
                        {option?.route}
                      </p>
                      <p className="text-sm text-muted-foreground">
                        {option?.description}
                      </p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-medium text-primary">
                      {option?.walkTime}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-6 p-4 bg-accent/10 rounded-lg border border-accent/20">
          <div className="flex items-start gap-3">
            <Icon name="Info" size={20} color="var(--color-accent)" className="mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-sm font-medium text-foreground mb-1">
                Accessibility
              </p>
              <p className="text-sm text-muted-foreground">
                Wheelchair accessible entrance and parking available. Please call ahead if you need any assistance.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParkingTransit;